import React from 'react';
import { Link } from 'react-router-dom';
import { track } from '../helpers/analytics';
import { t } from '../i18n';
import './ForumNavLink.scss';

/**
 * Small on-brand pill link into the community forum. Rendered as a floating
 * overlay on the map view (top-center, clear of the sign-in button and the
 * Mapbox controls).
 */
const ForumNavLink = () => (
    <Link
        to="/forum"
        className="forum-nav-link"
        aria-label={t('web.forum.openForum')}
        onClick={() => track('forum_nav_clicked', { source: 'map' })}
    >
        <span className="forum-nav-link__icon" aria-hidden="true">💬</span>
        {t('web.forum.navLabel')}
    </Link>
);

export default ForumNavLink;
